import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'

import { BorrowerPortalMessageThread } from './BorrowerPortalMessageThread'

export * from './BorrowerPortalMessageThread'

/**
 * The standalone Borrower Portal screen: the secure message thread with its own heading.
 *
 * The per-loan Servicing menu no longer reaches this - the thread is the Borrower Portal tab of
 * Servicing > Messages. It stays because `borrowerPortal` remains a configurable-page component,
 * so a tenant that already put Borrower Portal on a page of its own keeps the screen it built.
 */
export default function BorrowerPortal() {
  return (
    <div className="p-2 md:p-4">
      <div className="flex items-center gap-2 text-[16px] font-bold text-gray-900 border-b pb-1 mb-3 border-gray-200">
        <ChatBubbleLeftRightIcon className="w-5 h-5 text-shade-blue" />
        Secure Messages
      </div>
      <BorrowerPortalMessageThread />
    </div>
  )
}
